const decode = typeof atob === 'function' ? atob : str => Buffer.from(str, 'base64').toString();
export function decode64(encoded = '') {
    try {
        return decode(encoded);
    } catch (e) {
        return '';
    }
}
